/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Credit_CarriedInputs */



/**
* | output |
* | --- |
* | "Credit carried forward" |
*
* @param {Partner_Dashboard_Detail_Credit_CarriedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_credit_carried = /** @type {((inputs?: Partner_Dashboard_Detail_Credit_CarriedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Credit_CarriedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Übertragenes Guthaben")
	return /** @type {LocalizedString} */ ("Credit carried forward")
});